import React from 'react';
import { ACCENT_COLOR } from './colors';

const Folder = ({
  width = 18,
  className = '',
}) => (
  <svg
    className={`svg-icon ${className || ''}`}
    width={width}
    height={width}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path d="M16 16H2V8H16V16Z" stroke="#333333" strokeWidth="2" />
    <path d="M1 6H17V4H9L7 2H1V6Z" fill={ACCENT_COLOR} />
  </svg>
);

export default Folder;
